import React from "react";
import { Link } from "react-router-dom";
import { FiLinkedin } from "../assets/icons/vander";

export default function TeamCard({ item }) {
  const apiUrl = process.env.REACT_APP_STRAPI_URL;
  return (
    <div className="lg:col-span-3 md:col-span-6 text-sidom-light mb-[100px]">
      <div className="group text-center">
        <div className="relative inline-block mx-auto h-52 w-52 rounded-full overflow-hidden">
          <img
            src={`${apiUrl}${item.img.formats?.thumbnail.url}`}
            className="object-cover w-full h-full "
            alt={item.nombre}
          />

          <ul className="list-none absolute top-1/2 -translate-y-1/2 -end-20 group-hover:end-5 transition-all duration-500 ease-in-out">
            <li className="mt-1">
              {item.url && item.url[0]?.children?.[1]?.children?.[0]?.text ? (
                <a
                  href={item.url[0].children[1].children[0].text}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="h-8 w-8 inline-flex items-center text-center justify-center text-base font-normal tracking-wide border align-middle transition duration-500 ease-in-out rounded-full bg-orange-500 hover:bg-orange-600 border-orange-500 hover:border-orange-600 text-white"
                >
                  <FiLinkedin className="h-4 w-4" />
                </a>
              ) : null}
            </li>
          </ul>
        </div>

        <div className="content mt-3">
          <Link
            to=""
            className="text-lg font-medium text-sidom-light duration-500"
          >
            {item.nombre}
          </Link>
          <p className=" text-sidom-orange">{item.cargo}</p>
        </div>
      </div>
    </div>
  );
}
